// extracted by mini-css-extract-plugin
export default {"homeMage":"style_homeMage__Xb5rD","texts":"style_texts__ybj59","homeContainer":"style_homeContainer__6l797","float":"style_float__ErTWM","float2":"style_float2__caqr2"};